var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",staticClass:"inline-block align-baseline",attrs:{"width":_vm.scale ? null : _vm.width,"height":_vm.scale ? null : _vm.height,"fill":"currentColor"}})}
var staticRenderFns = []

export { render, staticRenderFns }